module.exports = __webpack_public_path__ + "static/media/edit-pen.9579887d.svg";